import { updatePrice } from './helper';

export const sortProducts = (products, sortOrder) => {
  switch (sortOrder) {
    case 'low-to-high':
      return [...products].sort((a, b) => {
        // First, sort by price
        if (updatePrice(a) !== updatePrice(b)) {
          return updatePrice(a) - updatePrice(b);
        }
        // If prices are equal, sort by title
        return a.title.localeCompare(b.title);
      });
    case 'high-to-low':
      return [...products].sort((a, b) => {
        // First, sort by price in descending order
        if (updatePrice(a) !== updatePrice(b)) {
          return updatePrice(b) - updatePrice(a);
        }
        // If prices are equal, sort by title
        return a.title.localeCompare(b.title);
      });
    case 'new-added':
      return [...products]
        .filter((product) => product.badgeTitle.toLowerCase() === 'new')
        .sort((a, b) => a.title.localeCompare(b.title)); // Sort by title for consistent ordering
    case 'on-sale':
      return [...products]
        .filter((product) => product.badgeTitle.includes('%'))
        .sort((a, b) => a.title.localeCompare(b.title)); // Sort by title for consistent ordering
    default:
      return products;
  }
};
